import HJPlayer from 'hjplayer';
import { createMsePlayer } from './msePlayer';
import { createWebRtcPlayer } from './webrtcPlayer';
const KIND_TO_TYPE = {
    flv: 'flv',
    hls: 'm3u8',
};
function defaultPlayerOptions(playback) {
    if (playback.kind === 'hls') {
        return {
            autoStartLoad: true,
            startPosition: -1,
            enableWorker: true,
            startFragPrefetch: true,
        };
    }
    if (playback.isLive) {
        return {
            enableWorker: true,
            enableStashBuffer: false,
        };
    }
    return {
        enableStashBuffer: false,
        autoCleanupSourceBuffer: true,
    };
}
export const BroadcastPlayerEvents = {
    MEDIA_INFO: (HJPlayer.Events && HJPlayer.Events.MEDIA_INFO) || 'MEDIA_INFO',
    ERROR: (HJPlayer.Events && HJPlayer.Events.ERROR) || 'ERROR',
};
export const isBroadcastPlayerSupported = () => Boolean(HJPlayer.isSupported && HJPlayer.isSupported());
export function createBroadcastPlayer(playback, extras) {
    if (playback.kind === 'mse') {
        return createMsePlayer(playback);
    }
    if (playback.kind === 'webrtc') {
        return createWebRtcPlayer(playback);
    }
    const type = KIND_TO_TYPE[playback.kind];
    if (!type) {
        throw new Error(`Unsupported video playback kind: ${playback.kind}`);
    }
    return new HJPlayer(Object.assign({ type, isLive: playback.isLive, hasAudio: false, hasVideo: true, url: playback.url }, extras === null || extras === void 0 ? void 0 : extras.media), Object.assign(Object.assign({}, defaultPlayerOptions(playback)), extras === null || extras === void 0 ? void 0 : extras.player));
}
